export default {
  bind(el, binding) {
    // 获取下拉框元素
    const dropDownDom = el.querySelector('.ivu-select-dropdown')
    // 下拉框监听事件
    dropDownDom.addEventListener('scroll', function () {
      const isDown = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (isDown) {
        binding.value && binding.value()
      }
    })
  }
}